import { render } from "./TreeNode.vue?vue&type=template&id=bd49b59a&scoped=true"
import script from "./TreeNode.vue?vue&type=script&lang=js"
export * from "./TreeNode.vue?vue&type=script&lang=js"

import "./TreeNode.vue?vue&type=style&index=0&id=bd49b59a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd49b59a"]])

export default __exports__